import AllergiesPage from "./AllergiesPage";

export default AllergiesPage;